import { redirectTo } from '@reach/router';

/**
 * 
 * @param {Boolean} isAuthenticated 
 * @param {String} currentLoggedInTenantId
 * @description Determines where to redirect when the application
 * is routed to the base URL.
 */
const Root = ({ isAuthenticated, currentLoggedInTenantId }) => {

    if (isAuthenticated && !currentLoggedInTenantId) {
        return (
            null
        );
    }

    if (currentLoggedInTenantId) {
        redirectTo(`/${currentLoggedInTenantId}/flows`);
    }

    return null;
};

export default Root;
